<template>
  <div class="home_section">
    <router-link class=" link top_link" to="/about">About </router-link>
    <router-link class=" link left_link" to="/portfolio">portfolio </router-link>
    <router-link class=" link right_link" to="/contact">contact </router-link>
    <router-link class=" link bottom_link" to="/strength">strength </router-link>
    <base-loader v-if="isLoading"></base-loader>
    <div v-else class="home_wrapper">
      <div>
        <h4 class="home_text">Hello, I'm :</h4>
      </div>
      <div>
        <h1 class="home_text">Imad Chaichaa</h1>
      </div>
      <div>
        <h3 class="home_text">And I'm a <the-typo /></h3>
      </div>
    </div>
  </div>
</template>

<script>
import TheTypo from "@/components/layout/TheTypo";
import BaseLoader from "@/components/base/BaseLoader";

export default {
  name: "home",
  components: {
    TheTypo,
    BaseLoader
  },
  data() {
    return {
      isLoading : true,
    }
  },
  mounted() {
    this.isLoading = false;
  }
}
</script>

<style scoped>
  .home_wrapper {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    padding-left: 20%;
    color: white;
    flex-direction: column;
  }

  .home_text {
    font-weight: 800;
  }

  .typo_text{
    color: #f6483b;
  }

  .home_section {
    width: 100%;
    min-height: 100vh;
    background-image: url("../assets/images/home.jpg");
    background-position: center;
    background-size: cover;
  }

  .link {
    position: absolute;
    color: #ffffff;
    text-transform: uppercase;
    font-weight: 800;
    letter-spacing: 5px;
    text-decoration: none;
  }

  .top_link {
    top: 3%;
    right:50%;
    transform: translateX(50%);
  }

  .bottom_link {
    bottom: 3%;
    right:50%;
    transform: translateX(50%);
  }

  .left_link {
    top: 50%;
    left:0;
    transform: rotate(-90deg) translateX(25%);
  }

  .right_link {
    top: 50%;
    right:0;
    transform: rotate(90deg) translateX(-25%);
  }
  @media (max-width: 768px) {
    .right_link {
      right: -5%;
    }
    .left_link {
      left: -5%;
    }
  }
</style>